/** Display label: OT-42 or fallback UUID short. */
export function formatOtLabel(otNumber: number | null | undefined, id: string): string {
  if (otNumber != null && otNumber > 0) return `OT-${otNumber}`;
  return `OT ${id.slice(0, 8).toUpperCase()}`;
}
